import axios from 'axios';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { TagId } from '@/shared/models/Tag';
import { present } from '@/shared/utils/typescript';
import { parseTimeRegistration, parseTimeRegistrationContainer } from '../converters/timeRegistrationConverters';
import { JobId } from '../models/AbstractJob';
import Job from '../models/Job';
import TimeRegistration, { TimeRegistrationId } from '../models/TimeRegistration';
import TimeRegistrationContainer from '../models/TimeRegistrationContainer';

export interface TimeRegistrationStopResult {
  timeRegistration: TimeRegistration;
  hasAllJobsStopped: boolean;
}

class TimeRegistrationClient {
  async loadAll(dossierId: DossierId): Promise<TimeRegistrationContainer> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/timeentries`);
    return present(parseTimeRegistrationContainer(response.data));
  }

  async create(dossierId: DossierId, jobs: Array<Job>): Promise<TimeRegistration> {
    const response = await axios.post(`/api/mobopro/v1/dossiers/${dossierId}/timeentries`, {
      jobIds: jobs.map(j => j.id),
    });
    return present(parseTimeRegistration(response.data));
  }

  async stop(id: TimeRegistrationId, jobIds: Array<JobId>, pauseReasonId: TagId | null, dossierId: DossierId): Promise<TimeRegistrationStopResult> {
    const data = { jobIds, pauseReasonId };
    const response = await axios.put(`/api/mobopro/v1/dossiers/${dossierId}/timeentries/${id}/stop`, data);
    return {
      timeRegistration: present(parseTimeRegistration(response.data.timeEntry)),
      hasAllJobsStopped: response.data.hasAllJobsStopped,
    };
  }
}

export default new TimeRegistrationClient();